import {ucFirst} from './utils'

// Generate default getters and mutators for modules
export function bootstrapModule (module) {
  if (module == null) {
    return
  }

  if (module.getters === undefined) {
    module.getters = {}
  }

  if (module.mutations === undefined) {
    module.mutations = {}
  }

  if (module.hasOwnProperty('state')) {
    _addGettersAndMutations(module)
  }

  return module
}

function _addGettersAndMutations (module) {
  Object.keys(module.state).forEach(property => {
    if (!module.getters[property]) {
      module.getters[property] = state => state[property]
    }
    if (!module.mutations[property]) {
      module.mutations[property] = (state, value) => {
        state[property] = value
      }
    }

    if (module.state[property]
      && typeof module.state[property] === 'object'
      && !Array.isArray(module.state[property])) {
      _addNestedGettersAndMutations(module, property)
    }
  })
}

function _addNestedGettersAndMutations (module, parent) {
  Object.keys(module.state[parent]).forEach(property => {
    if (!module.getters[parent + ucFirst(property)]) {
      module.getters[parent + ucFirst(property)] = state => state[parent][property]
    }
    if (!module.mutations[parent + ucFirst(property)]) {
      module.mutations[parent + ucFirst(property)] = (state, value) => {
        state[parent][property] = value
      }
    }
  })
}